// src/components/AnnouncementPopup.jsx
//
// Объявление-попап при запуске (пишется в суперадминке → GET /app/announcements).
// Каждое показываем один раз: что уже видели — помнит устройство (localStorage).
// Только на главном экране — чтобы не выскочить посреди продажи на кассе.

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { app as appApi } from '../api';
import Icon from './Icon';

const SEEN_KEY = 'alsatuu:ann:seen';

function readSeen() {
  try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]') || []; } catch (e) { return []; }
}
function markSeen(id) {
  try {
    const seen = readSeen().filter(x => x !== id);
    seen.push(id);
    localStorage.setItem(SEEN_KEY, JSON.stringify(seen.slice(-50)));
  } catch (e) { /* не критично: покажем ещё раз */ }
}

const atRoot = () => {
  const h = window.location.hash || '';
  return h === '' || h === '#/' || h === '#';
};

export default function AnnouncementPopup({ audience }) {
  const { t, i18n } = useTranslation();
  const [queue, setQueue] = useState([]);
  const [root, setRoot] = useState(atRoot);
  const [imgOk, setImgOk] = useState(true);

  useEffect(() => {
    let cancelled = false;
    // Чуть позже старта — не мешаем первой загрузке экрана
    const timer = setTimeout(async () => {
      try {
        const list = await appApi.announcements(audience, i18n.language);
        const seen = new Set(readSeen());
        if (!cancelled && Array.isArray(list)) setQueue(list.filter(a => a && a.id && !seen.has(a.id)));
      } catch (e) { /* нет сети — без объявлений */ }
    }, 1500);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [audience]); // eslint-disable-line

  useEffect(() => {
    const h = () => setRoot(atRoot());
    window.addEventListener('hashchange', h);
    return () => window.removeEventListener('hashchange', h);
  }, []);

  const cur = queue[0];
  if (!cur || !root) return null;

  const next = () => {
    markSeen(cur.id);
    setImgOk(true);
    setQueue(q => q.slice(1));
  };
  const openLink = () => {
    try { window.open(cur.buttonUrl, '_blank'); } catch (e) { /* ignore */ }
    next();
  };

  return (
    <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && next()} style={{ zIndex: 1000 }}>
      <div className="modal-sheet" style={{ maxWidth: 520, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 12 }}>
          <p style={{ flex: 1, fontSize: 19, fontWeight: 800, fontFamily: 'var(--font-display)', lineHeight: 1.25 }}>
            {cur.title}
          </p>
          <button className="modal-close" onClick={next} aria-label={t('common.close')}>
            <Icon name="x" size={16} />
          </button>
        </div>
        {cur.imageUrl && imgOk && (
          <img
            src={cur.imageUrl}
            alt=""
            onError={() => setImgOk(false)}
            style={{ width: '100%', maxHeight: '40vh', objectFit: 'contain', borderRadius: 'var(--r-md)', marginBottom: 12, background: 'var(--bg-subtle)' }}
          />
        )}
        {cur.body && (
          <p style={{ fontSize: 15, lineHeight: 1.5, whiteSpace: 'pre-line', color: 'var(--fg)', marginBottom: 16, maxHeight: '40vh', overflowY: 'auto' }}>
            {cur.body}
          </p>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingBottom: 'env(safe-area-inset-bottom)' }}>
          {cur.buttonUrl && (
            <button className="btn btn-primary btn-lg" onClick={openLink}>
              {cur.buttonText || t('common.open')}
            </button>
          )}
          <button className={cur.buttonUrl ? 'btn btn-secondary' : 'btn btn-primary btn-lg'} onClick={next}>
            {t('common.close')}
          </button>
        </div>
      </div>
    </div>
  );
}
